'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdAccountBalance = function MdAccountBalance(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm19.1 1.6l15.9 8.4v3.4h-31.6v-3.4z m7.5 15h5v11.8h-5v-11.8z m-23.2 20v-5h31.6v5h-31.6z m13.2-20h5v11.8h-5v-11.8z m-10 0h5v11.8h-5v-11.8z' })
        )
    );
};

exports.default = MdAccountBalance;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/account-balance.js
// module id = 699
// module chunks = 36573943044255 79611799117203 213534597649335